import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_cf4fc7f2-a73a-4fe6-9ce3-8070ac060fc8/artifacts/f8wsr7qm_Logo-01.jpg";

const links = [
  { href: "#services", label: "Services" },
  { href: "#who-we-help", label: "Who We Help" },
  { href: "#how-it-works", label: "How It Works" },
  { href: "#pricing", label: "Pricing" },
  { href: "#book", label: "Book" },
  { href: "#faq", label: "FAQ" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      style={{ top: "var(--promo-bar-h, 0px)" }}
      className={`sticky z-40 bg-[var(--paper)] border-b-2 border-ink transition-[top,box-shadow] duration-300 ${
        scrolled ? "shadow-[0_4px_0_0_#1c1917]" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo-link"
          className="flex items-center gap-3"
        >
          <img
            src={LOGO_URL}
            alt="iAriya AI logo"
            className="h-12 w-auto object-contain"
            data-testid="nav-logo-image"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-semibold text-stone-800 hover:text-[var(--pink)] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#book"
            data-testid="nav-cta-book-consultation"
            className="btn-ink hidden md:inline-flex items-center gap-2 bg-[var(--blue)] text-white px-5 py-2.5"
          >
            Book a free consultation
          </a>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden p-2 border-2 border-ink rounded-lg bg-white"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden border-t-2 border-ink bg-white px-5 py-4 space-y-3"
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block font-semibold py-2"
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#book"
            onClick={() => setOpen(false)}
            className="btn-ink inline-flex bg-[var(--blue)] text-white px-5 py-2.5"
            data-testid="nav-mobile-cta"
          >
            Book a free consultation
          </a>
        </div>
      )}
    </header>
  );
};
